/**
 * @file 训练与推理技术
 * @author Fanjinliang(fanjinliang@baidu.com)
 */

import React from 'react';
import { ReasoningTech } from '../../types';
import { Row, Col } from 'antd';

interface IProps {
    inferenceList: ReasoningTech;
}

const PaddleNlpInference: React.FC<IProps> = props => {
    const {
        inferenceList: { list }
    } = props;
    return (
        <Row justify="space-around" className="paddle-icon-card-wrap nlp-inference-container">
            {list.map((item, index) => (
                <Col className="paddle-icon-card" key={index} xs={6}>
                    <div className="paddle-icon-card-icon-wrap">
                        <div className="paddle-icon-card-icon" style={{ backgroundImage: `url(${item.imageUrl})` }}>
                            <img alt={item.title} src={item.imageUrl} />
                        </div>
                    </div>
                    <div className="paddle-icon-card-title">{item.title}</div>
                    <div className="paddle-text-card2-link">
                        <a href={item.bthLink}>{item.btnWord}</a>
                    </div>
                </Col>
            ))}
        </Row>
    );
};

export default PaddleNlpInference;
